import React, { useState } from "react";
import { BundleCard } from "@/features/bundles/BundleCard";
import { DrawerPageProps } from "../types";
import { Bundle } from "../../types";
import { BundleProvider } from "../../BundleContext";
import { Button } from "@/components/Button";
import { BundleDrawerFooter } from "../BundleDrawerFooter";
import { BundleDrawer, Page } from "..";
import { ConfirmBundlePage } from "./ConfirmBundlePage";

type SelectBundlePageProps = DrawerPageProps & {
  onSelect: (bundle: Bundle) => void;
  bundles: Bundle[];
};

export const SelectBundlePage = ({
  bundles,
  ...rest
}: SelectBundlePageProps) => {
  const [openedDrawer, setOpenedDrawer] = useState<Page | undefined>(undefined);
  const [selectedBundle, setSelectedBundle] = useState(bundles[1]);
  return (
    <>
      <div className="grow space-y-5 p-5">
        {bundles.map((bundle) => {
          return (
            <BundleProvider key={bundle.title} bundle={bundle}>
              <BundleCard
                onChange={() => {
                  setSelectedBundle(bundle);
                }}
                value={selectedBundle === bundle}
              />
            </BundleProvider>
          );
        })}
      </div>
      <BundleDrawerFooter>
        <Button
          className="w-full"
          size="lg"
          onClick={() => setOpenedDrawer({ kind: "confirm-bundle" })}
        >
          Next step
        </Button>
      </BundleDrawerFooter>
      <BundleDrawer
        open={openedDrawer !== undefined}
        title="Select your bundle"
        contents={(nav) =>
          openedDrawer !== undefined ? (
            <ConfirmBundlePage {...nav} bundle={selectedBundle} />
          ) : null
        }
        {...rest}
        onBack={() => setOpenedDrawer(undefined)}
        transparentBackdrop={true}
      />
    </>
  );
};
